import React, { Component } from 'react'
import ReactDom from 'react-dom'
import App from './App'
import './web.scss'

// import BootstrapTest from './bootstrap/BootstrapTest'

// ReactDom.render(<App />,document.getElementById('root'))

ReactDom.render(<App />, document.getElementById('root'))
